import React from 'react';
import ReactQuill from 'react-quill-new';

import { useUiField } from '../hooks';
import { UiField } from './UiField';

const modules = {
  toolbar: false,
};

export const UiReadOnlyQuill = props => {
  const [uiFieldProps, inputProps] = useUiField(props, {
    isTextarea: true,
    onFocus: () => {},
    onBlur: () => {},
  });
  const blacklist = ['onFocus', 'onBlur'];
  return (
    <UiField {...uiFieldProps} errorMessage="" hasError="" disabled>
      <ReactQuill
        theme="snow"
        readOnly
        {...Object.fromEntries(
          Object.entries(inputProps).filter(([k]) => !blacklist.includes(k))
        )}
        modules={modules}
        useSemanticHTML={false}
      />
    </UiField>
  );
};
